import React from 'react';

import illustration from '../../../assets/images/investorEmptyState.svg';
import startsHere from '../../../assets/images/startsHere.svg';
import css from './style.scss';

// Pre-search state of the results pane — Figma node 291:8804 (Frame 1477389).
// Copy is verbatim from the design; the map stays visible alongside but carries
// no investor data until a search runs.
const EmptyState = () => (
  <div className={css.container}>
    {/* Figma 483:32178 — the onboarding hint, an arrow curving back out of this
        pane towards the Subject Property field. Anchored to the pane's top-left
        so it never collides with the centred illustration and copy below.
        Exported whole, lettering outlined, so it needs no handwriting webfont. */}
    <img src={startsHere} alt="Starts here!" className={css.annotation} />
    <img src={illustration} alt="" className={css.illustration} />
    <div className={css.copy}>
      <p className={css.title}>Connect with Investors Who Are Already Buying</p>
      <p className={css.subtitle}>
        Enter any property address to discover active investors, save contacts, skip trace, and
        start reaching out—all from one place.
      </p>
    </div>
  </div>
);

export default EmptyState;
